import { DOCUMENT } from '@angular/common';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Ipo } from 'src/app/core/models/ipo';

@Component({
  selector: 'app-detail',
  encapsulation:ViewEncapsulation.None,
  templateUrl: './detail.component.html',
  styleUrls: ['./detail.component.scss']
})
export class DetailComponent implements OnInit {
  ipo: Ipo;

  constructor(
    public translate: TranslateService,
    public router: Router,
  ) { }

  ngOnInit(): void {
    this.router.navigate([this.router?.url?.replace('public-offering','ipo-calendar')])
  }

}
